import dayjs from 'dayjs';

export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_WEEK = 7 * ONE_DAY;

/**
 * Truncate a date to reduce its precision to a given time period (minute, hour, day, etc.).
 * @param date {Date} the date to be truncated
 * @param timePeriod {Number} the time period in milliseconds to truncate the date to
 * @returns {Date} the truncated date
 */
export function truncateDate(date, timePeriod) {
    return new Date(Math.floor(date.getTime() / timePeriod) * timePeriod);
}

/**
 * 초 단위 남은 시간을 MM:SS 형식의 타이머 문자열로 변환
 * @param seconds 초 단위 시간
 * @returns {string}
 */
export function formatSecondsTimer(seconds) {
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    const restSeconds = String(seconds % 60).padStart(2, '0');

    return `${minutes}:${restSeconds}`;
}

/**
 * 만료 시각까지 남은 초를 계산
 * @param expiresAt 만료 시각
 * @param fallbackSeconds 만료 시각이 없거나 파싱할 수 없을 때 사용할 기본 초
 * @param now 현재 시각
 * @returns {number}
 */
export function getSecondsLeftUntil(expiresAt, fallbackSeconds = 0, now = Date.now()) {
    if (!expiresAt) return fallbackSeconds;

    const expiresMs = Date.parse(expiresAt);
    if (Number.isNaN(expiresMs)) return fallbackSeconds;

    const diff = Math.floor((expiresMs - now) / ONE_SECOND);
    return diff > 0 ? diff : 0;
}

/**
 * 날짜 포맷에 사용할 함수
 * @param date
 * @param format optional
 * @returns {string}
 */
export function formatDate(date, format = null) {
    return dayjs(date).format(format ? format : 'YYYY.MM.DD');
}

/**
 * 한국어 날짜 포맷
 * @param date
 * @param format
 * @returns {string}
 */
export function formatKoreanDate(date, format = null) {
    return dayjs(date).format(format ? format : 'YYYY년 M월 DD일');
}
